var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Divider, Typography } from '@mui/material';
import DrawerComponent from '@src/components/Atoms/Drawer/Drawer';
import Input from '@src/components/Atoms/Input/Input';
import { useState } from 'react';
import { toast } from 'react-toastify';
import { useJob } from '@src/app/pages/JobPage/JobHooks/Job.hooks';
var RejectJob = function (_a) {
    var isOpen = _a.isOpen, handleClose = _a.handleClose, record = _a.record, id = _a.id;
    var cancelJob = useJob(undefined, false).cancelJob;
    var _b = useState(false), isSubmitting = _b[0], setIsSubmitting = _b[1];
    var _c = useState(''), reason = _c[0], setReason = _c[1];
    var handleRejectSettings = function () { return __awaiter(void 0, void 0, void 0, function () {
        var formValues, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setIsSubmitting(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    formValues = {
                        id: id,
                        reason: reason,
                    };
                    if (!reason || reason === '') {
                        toast.error('Silahkan masukkan alasan reject');
                        setIsSubmitting(false);
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, cancelJob(formValues)];
                case 2:
                    _a.sent();
                    setIsSubmitting(false);
                    setTimeout(function () {
                        handleClose(false);
                    }, 1000);
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    toast.error(error_1.response.data.message);
                    setIsSubmitting(false);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    return (_jsx(DrawerComponent, __assign({ open: isOpen, handleClose: function () { return handleClose(false); }, title: 'Cancel Job' }, { children: record && (_jsxs("div", { children: [_jsxs("div", __assign({ className: 'mb-3' }, { children: [_jsx("div", { children: _jsx(Typography, __assign({ variant: 'body1' }, { children: "Nama Talent" })) }), _jsx("div", { children: _jsx(Typography, __assign({ variant: 'h6' }, { children: record.talent.name })) })] })), _jsxs("div", __assign({ className: 'mb-3' }, { children: [_jsx("div", { children: _jsx(Typography, __assign({ variant: 'body1' }, { children: "Contact Person" })) }), _jsx("div", { children: _jsxs(Typography, __assign({ variant: 'h6' }, { children: [record.talent.cpName, " - ", record.talent.cpPhoneNumber] })) })] })), _jsx(Divider, {}), _jsxs("div", __assign({ className: 'my-5' }, { children: [_jsx("div", __assign({ className: 'mb-3' }, { children: _jsx(Typography, __assign({ variant: 'body1' }, { children: "Alasan" })) })), _jsx("div", { children: _jsx(Input, { name: 'reason', placeholder: 'Alasan', value: reason, type: 'text', onChange: function (e) { return setReason(e.target.value); } }) })] })), _jsx(Divider, {}), _jsx("div", __assign({ className: 'my-5' }, { children: _jsxs("div", __assign({ style: { textAlign: 'right' } }, { children: [_jsx("button", __assign({ type: 'button', className: 'btn btn-secondary btn-active-light-primary', onClick: function () { return handleClose(false); }, disabled: isSubmitting, style: { marginRight: '1rem' } }, { children: "Batal" })), _jsxs("button", __assign({ type: 'button', className: 'btn btn-primary btn-active-light-primary mr-2', onClick: handleRejectSettings, disabled: isSubmitting }, { children: [!isSubmitting && _jsx("span", __assign({ className: 'indicator-label' }, { children: "Simpan" })), isSubmitting && (_jsxs("span", __assign({ className: 'indicator-progress', style: { display: 'block' } }, { children: ["Mohon tunggu...", _jsx("span", { className: 'spinner-border spinner-border-sm align-middle ms-2' })] })))] }))] })) }))] })) })));
};
export default RejectJob;
